var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{ref:"ch_wsf_action",attrs:{"type":"bar","height":"350","options":_vm.chart_option,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }